import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../utils/supabaseClient';
import { logoImg } from '../../utils/images';
import '../../components/LoginSupabase/LoginS.scss';
import './ForgotPasswordPage.scss';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }

    setIsLoading(true);
    try {
      const trimmedEmail = email.trim();
      await supabase.auth.signOut({ scope: 'local' });
      const { error } = await supabase.auth.resetPasswordForEmail(trimmedEmail);
      if (error) throw error;
      navigate(`/email-otp?flow=recovery&email=${encodeURIComponent(trimmedEmail)}`);
    } catch (err: any) {
      setError(err.message || 'Failed to send reset code. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgotPasswordPage">
      <div className="login">
        <div className="login__container">
          <div className="login__t">
            <div className="login__logo-wrapper">
              <img src={logoImg} alt="Dovery" className="login__logo" />
            </div>

            <form className="login-form" onSubmit={handleSubmit}>
                <p className="auth-form__description">
                  Enter your email address and we'll send you a one-time code to reset your password.
                </p>

                <div className="login-form__field">
                  <input
                    type="email"
                    className="login-form__input"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                </div>

                {error && <p className="login-form__error">{error}</p>}

                <button
                  type="submit"
                  className="login-form__submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Sending...' : 'Send Reset Code'}
                </button>

                <div className="login-form__divider">
                  <span className="login-form__divider-text">or</span>
                </div>

                <button
                  type="button"
                  className="login-form__back"
                  onClick={() => navigate('/')}
                >
                  Back to Login
                </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
